import { render } from "./FeedPetStage.vue?vue&type=template&id=64e49726"
import script from "./FeedPetStage.vue?vue&type=script&lang=js"
export * from "./FeedPetStage.vue?vue&type=script&lang=js"

import "./FeedPetStage.vue?vue&type=style&index=0&id=64e49726&lang=css"

import exportComponent from "/builds/sites/smolke/app-kwispelcoach-com/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__